<template>
  <div class="main">
    <el-container>
      <!--头部内容-->
      <el-header style="height: 100px;" class="headerStyle">
        <el-row>
          <el-col :span="6">
            <div class="logo"><img src="@/assets/pictures/logo.png"/></div>
          </el-col>
          <el-col :span="14">
            <div class="titleStyle">{{ $t("title.Main Title") }}</div>
          </el-col>
          <el-col :span="4">
            <div class="user">
              <div class="img" style="display: inline">
                <el-avatar :size="50" style="margin-top: 10px"> user</el-avatar>
              </div>
              <div class="setting" style="display: inline">
                <el-dropdown trigger="click" @command="handleCommand" class="user-name">
                  <span class="el-dropdown-link" style="color: white;font-size: 15px"> {{ username }} <i
                      class="el-icon-caret-bottom"></i></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="change">{{ $t("button.Modify the password") }}</el-dropdown-item>
                    <el-dropdown-item command="modify">{{ $t("button.Modify the information") }}</el-dropdown-item>
                    <el-dropdown-item command="loginout">{{ $t("button.Log out") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <img src="@/assets/pictures/bg.png"/>

      <el-container>
        <!--导航栏-->
        <el-aside class="nav">
          <navigation></navigation>
        </el-aside>

        <!--展示内容框-->
        <el-main>
          <router-view/>
        </el-main>

      </el-container>
    </el-container>
  </div>
</template>

<script>
import navigation from "@/components/common/Navigation";
import request from "@/utils/request";

export default {
  name: "Home",
  components: {
    navigation
  },
  data() {
    return {
      username: "", // 初始化为一个空字符串
    };
  },
  // 在 created 钩子中获取并设置 username
  created() {
    this.username = window.sessionStorage.getItem("username");
  },
  methods: {
    handleCommand(command) {// 用户名下拉菜单选择事件
      if (command === 'loginout') {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('username')
        window.sessionStorage.removeItem('years')
        localStorage.clear();
        request.get('/logout')
        this.$router.push({
          path: '/login'
        });
      }
      if (command === 'modify') {
        this.$router.push({
          path: '/userModify'
        });
      }
      if (command === 'change') {
        this.$router.push({
          path: '/passwordModify'
        });
      }
    }
  }
}
</script>

<style scoped>
.main {
  overflow: hidden;
}

.headerStyle {
  background-image: url("../assets/pictures/bg1.png");
}

.main {
  width: 100%;
  height: 100%;
  /*background: #f0f0f0;*/
}

.titleStyle {
  color: white;
  font-size: 28px;
  margin-top: 24px;
}

.nav {
  height: 600px;
}

.user {
  margin: 10px;
  float: right;
}

.user-name {
  margin-left: 10px;
}

.logo img {
  display: block;
  margin: 10px;
  width: 250px;
  height: 80px;
}

.el-dropdown-link {
  cursor: pointer;
}
</style>